import {Component, computed, inject} from '@angular/core';
import {IconName} from '@cov/ui-angular';
import {translate, TranslocoPipe} from '@jsverse/transloco';
import {CovIconComponent} from '../../../../../../../packages/ui-angular/src/lib/components/cov-icon/cov-icon.component';
import {Address} from '../../../interfaces/address.interface';
import {SoldToAddress} from '../../../interfaces/sold-to-address.interface';
import {ADDRESS_DIVIDER} from '../../constants';
import {SoldToShipToService} from '../../services/sold-to-ship-to.service';

@Component({
  selector: 'cov-sold-to-information',
  imports: [TranslocoPipe, CovIconComponent],
  templateUrl: './sold-to-information.component.html',
  styleUrl: './sold-to-information.component.scss',
})
export class SoldToInformationComponent {
  // INJECTS
  public soldToService = inject(SoldToShipToService);

  private allSoldTo: SoldToAddress = {
    id: '0',
    active: true,
    displayValue: translate('soldToInformation.allSoldTos'),
  };

  public allAddresses = computed(() => {
    return this.soldToService.allAddresses()?.map(this.mapToViewAddress.bind(this));
  });

  public currentSelectedAddress = computed(() => {
    return this.allAddresses()?.find((address: SoldToAddress) => address.active) ?? this.allSoldTo;
  });

  public shownSoldTo = computed(() => {
    const addresses = this.soldToService.allAddresses();
    if (addresses?.length === 1) {
      return this.mapToViewAddress(addresses[0]);
    }
    return null;
  });

  private mapToViewAddress(address: Address): SoldToAddress {
    return {
      id: address.id,
      displayValue: `${address.sapCustomerID} ${ADDRESS_DIVIDER} ${address.companyName} ${ADDRESS_DIVIDER} ${address.country?.name}`,
    };
  }

  protected readonly IconName = IconName;
}
